// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"9643f92c","787":"6060bfd7","910":"2facfec2"}[chunkId] + ".chunk.js";
};